module.exports = __webpack_public_path__ + "img/product.6065e534.png";